export const SECTION_ID_MAPPING = {
	DECISION_MAKERS: 'decision-makers',
	EMBEDDED_SIGN_FORM: 'embedded-sign-form',
	UPDATES: 'updates',
	MEDIA_MENTIONS: 'media-mentions',
	SUPPORTER_VOICES: 'supporter-voices',
} as const;

export const SECTION_IDS = Object.values(SECTION_ID_MAPPING);
